module.exports = __webpack_public_path__ + "img/tk.384369e9.svg";